import { lazy } from 'react';

export { default as Home } from './Home/Home';

export const FAQ = lazy(() => import('./FAQ/FAQ'));
export const Products = lazy(() => import('./Products/Products'));

//shared imports
export { default as Header } from './Shared/Header';
